import React from 'react';
import PropTypes from 'prop-types';

const SubHeader = ({
  id = null,
  as,
  children,
  subHeaderClassName = '',
  extraClassName = '',
}) => {
  const Component = as;
  const classString = `${subHeaderClassName} ${extraClassName}`;

  return (
    <Component id={id} className={classString}>
      {children}
    </Component>
  );
};

SubHeader.propTypes = {
  id: PropTypes.string,
  as: PropTypes.oneOf(['div', 'p']).isRequired,
  children: PropTypes.node.isRequired,
  subHeaderClassName: PropTypes.string,
  extraClassName: PropTypes.string,
};

export default SubHeader;
